<template>
    <div class="kiaf-sys-log-config">
        <div class="detail-wrapper">
            <div class="header">
                <h2 class="title">配置详情</h2>
            </div>
            <div class="form-body">
                <kc-form label-position="right" label-width="7rem" :rules="rules" :inline="true" :model="configInfo"
                         class="form-inline">
                    <kc-form-item label="高频访问" class="item" prop="frequentlyAccess">
                        <kc-input v-model="configInfo.frequentlyAccess" :disabled="!isAdd && !isEdit"></kc-input>
                    </kc-form-item>

                    <kc-form-item label="用户长期未使用(天)" class="item" prop="acctLongTimeUnused">
                        <kc-input v-model="configInfo.acctLongTimeUnused" :disabled="!isAdd && !isEdit"></kc-input>
                    </kc-form-item>
                    <kc-form-item label="规定时间外访问" class="area">
                        <div class="sernumtab-form-timebox">
                            <kc-time-picker
                                    placeholder="起始时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :disabled="!isAdd && !isEdit"
                                    v-model="configInfo.limitAccessBeginTime"
                                    :picker-options="{
                                        selectableRange:`00:00:00 -${configInfo.limitAccessEndTime ? getDataTime(configInfo.limitAccessEndTime)+ ':00' : '23:59:00'}`
                                      }">
                            </kc-time-picker>
                            <div class="sernumtab-timebox-txt">至</div>
                            <kc-time-picker
                                    placeholder="结束时间"
                                    :disabled="!isAdd && !isEdit"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="configInfo.limitAccessEndTime"
                                    :picker-options="{
                                         selectableRange:`${configInfo.limitAccessBeginTime ? getDataTime(configInfo.limitAccessBeginTime)+ ':00' : '00:00:00'}-23:59:00`
                                    }">
                            </kc-time-picker>
                        </div>
                    </kc-form-item>
                    <kc-form-item label="非常规业务" class="area" prop="specialBusiness">
                        <kc-select
                                :disabled="!isAdd && !isEdit"
                                v-model="configInfo.specialBusiness"
                                multiple
                                collapse-tags
                                placeholder="请选择">
                            <kc-option
                                    v-for="item in specialBusinessOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.label">
                            </kc-option>
                        </kc-select>
                    </kc-form-item>
                </kc-form>
            </div>
        </div>
        <div class="btn-wrapper">
            <div class="btn-group" v-show="btnGroupShow">
                <kc-button class="btn-origin btn-redact" @click="editConfig">
                    {{configInfo.id ? '编辑':'添加'}}
                </kc-button>
                <kc-button class="btn-origin btn-delete" @click="confirmBeforeDelete" :disabled="!configInfo.id">删除</kc-button>
            </div>
            <div class="btn-group" v-show="!btnGroupShow">
                <kc-button class="btn-origin btn-redact" @click="onSubmit">保存</kc-button>
                <kc-button class="btn-origin button--default" @click="cancelConfig">取消</kc-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getConfigApi,
        addConfigApi,
        editConfigApi,
        deleteConfigApi,
        getUnconventionalBusinessApi
    } from '../../service/sysLogConfig.js';

    export default {
        name: 'KiafSysLogConfig',
        data() {
            return {
                configInfo: {},
                rules: {
                    frequentlyAccess: [
                        {
                            pattern: /^[0-9]*$/,
                            message: '请输入数字',
                            trigger: 'change'
                        }
                    ],
                    acctLongTimeUnused: [
                        {
                            pattern: /^[0-9]*$/,
                            message: '请输入数字',
                            trigger: 'change'
                        }
                    ]
                },
                configInfoData: {},
                specialBusinessOptions: [],
                btnGroupShow: true,
                isEdit: false,
                isAdd: false
            };
        },
        created() {
          this.reset();
        },
        mounted() {
            this.getConfig();
            this.getUnconventionalBusiness();
        },
        watch: {
            configInfoData(val) {
                this.configInfo = {...val};
            }
        },
        methods: {
            reset(){
              this.configInfo = {
                  acctLongTimeUnused: '',
                  frequentlyAccess: '',
                  id: '',
                  limitAccessBeginTime: '',
                  limitAccessEndTime: '',
                  specialBusiness: []
              };
            },
            //gettime 'HH:mm:ss'
            getDataTime(time) {
                time = new Date(time);
                return time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds();
            },
            // 表单数据验证
            checkInputData() {
                //传输参数不能都为空
                let value = '';
                for (let key in this.configInfo) {
                    if (key === 'id') {
                        continue;
                    }
                    value += this.configInfo[key];
                }
                if (!value) {
                    this.$message.warning('不能添加空的配置!');
                    this.isEdit = false;
                    this.btnGroupShow = true;
                    this.configInfo = {...this.configInfoData};
                    return false;
                }
                //高频访问 用户长期未使用 表单验证
                let pattern = /^[0-9]*$/;
                let regAcctLongTimeUnused = pattern.test(this.configInfo.acctLongTimeUnused);
                let regfrequentlyAccess = pattern.test(this.configInfo.frequentlyAccess);
                if (!regAcctLongTimeUnused || !regfrequentlyAccess) {
                    this.$message.warning('请输入数字!');
                    return false;
                }
                //开始时间和结束时间都填或者都不填
                let a = this.configInfo.limitAccessBeginTime;
                let b = this.configInfo.limitAccessEndTime;
                let timeReg = ((!a || !b) === true) && ((!a && !b) === false);
                if (timeReg) {
                    this.$message.warning('开始时间和结束时间都填或者都不填!');
                    return false;
                }
                return true;
            },

            // 保存
            onSubmit() {
                let that = this;
                let isGoOn = that.checkInputData();
                if (!isGoOn) {
                    return;
                }
                if (that.isEdit) {
                    //修改配置
                    let params = {
                        ...that.configInfo
                    };
                    editConfigApi(params).then(result => {
                        if (result.id) {
                            that.configInfoData = {...result};
                            that.configInfoData.limitAccessBeginTime = new Date(result.limitAccessBeginTime);
                            that.configInfoData.limitAccessEndTime = new Date(result.limitAccessEndTime);
                            that.isEdit = false;
                            that.btnGroupShow = true;
                            that.$message.success('修改成功');
                        } else {
                            that.$message.error(result.message);
                        }
                    });
                } else if (that.isAdd) {
                    //添加配置
                    let params = {
                        ...that.configInfo
                    };
                    addConfigApi(params).then(result => {
                        if (result.id) {
                            that.configInfoData = {...result};
                            that.configInfoData.limitAccessBeginTime = new Date(result.limitAccessBeginTime);
                            that.configInfoData.limitAccessEndTime = new Date(result.limitAccessEndTime);
                            that.isAdd = false;
                            that.btnGroupShow = true;
                            that.$message.success('添加成功');
                        } else {
                            that.$message.error(result.message);
                        }
                    });
                }
            },

            //取消编辑
            cancelConfig() {
                this.isEdit = false;
                this.btnGroupShow = true;
                this.configInfo = {...this.configInfoData};
            },

            //删除配置
            confirmBeforeDelete(){
              this.$confirm('确定要删除该配置么？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                 this.deleteConfig();
              });
            },
            deleteConfig() {
                const params = {
                    id: this.configInfo.id
                };
                deleteConfigApi(params).then(result => {
                    if (result.status === 200) {
                        this.reset();
                        this.getConfig();
                        this.$message.success('删除成功');
                    } else {
                        this.$message.error(result.message);
                    }
                });
            },

            //修改配置
            editConfig() {
                if (this.configInfo.id) {
                    this.isAdd = false;
                    this.isEdit = true;
                } else {
                    this.isAdd = true;
                    this.isEdit = false;
                }
                this.btnGroupShow = false;
            },

            //查询配置
            getConfig() {
                getConfigApi().then(result => {
                    if (result.id) {
                        this.configInfoData = {...result};
                        this.configInfoData.limitAccessBeginTime = result.limitAccessBeginTime;
                        this.configInfoData.limitAccessEndTime = result.limitAccessEndTime;
                    } else {
                        this.$message.error(result.message);
                    }
                });
            },

            getUnconventionalBusiness() {
                getUnconventionalBusinessApi().then(result => {
                    if (result.moduleOptions) {
                        result.moduleOptions.map(item => {
                            this.specialBusinessOptions.push({value: item.cd, label: item.description});
                        });
                    }
                });
            }
        }
    };
</script>
<style lang="scss">
    @import "index.scss";
</style>
